module.exports = __webpack_public_path__ + "assets/img/yuncong_logo@2x.c7253eff.png";